module.exports = __webpack_public_path__ + "img/SKMJ_standard1.53b2c57f.jpg";